/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Sort_Order_HintInputs */

const vi_shop_group_sort_order_hint = /** @type {(inputs: Shop_Group_Sort_Order_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số nhỏ đứng trước, dùng chung cho mọi danh mục của nhóm.`)
};

/**

* @param {Shop_Group_Sort_Order_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_sort_order_hint = /** @type {((inputs?: Shop_Group_Sort_Order_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Sort_Order_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_sort_order_hint(inputs)
});